import React, { Component } from 'react'
import { Link } from 'react-router-dom';
import './home.less';
import icon from '../../assets/icon.png'
const Header = (props) => {
    return (
        <div className="deja-nav-bar">
        <ul className="nav-bar">
          <li>
            <Link to="/"><span style={{display: 'inline-block', width: '63px'}}><img style={{maxWidth: '100%'}} src={icon} /></span></Link>
          </li>
        </ul>
      </div>
    )
}
export default class Layout extends Component {
    render () {
        return (
            <div>
                <Header />
                <div style={{paddingTop: '45px'}}>
                    {this.props.children}
                </div>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/features/layout/homeLayout.js